import { render, staticRenderFns } from "./EventSubmissionCard.vue?vue&type=template&id=518ccff6&scoped=true&lang=pug"
import script from "./EventSubmissionCard.vue?vue&type=script&lang=js"
export * from "./EventSubmissionCard.vue?vue&type=script&lang=js"
import style0 from "./EventSubmissionCard.vue?vue&type=style&index=0&id=518ccff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ccff6",
  null
  
)

export default component.exports